import React from 'react'

function Shirt ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="30" height="30" viewBox="0 0 30 30">
      <path d="M27,30H3a3.009,3.009,0,0,1-3-3V3A3.009,3.009,0,0,1,3,0H9V.75a6,6,0,0,0,12,0V0h6a3.009,3.009,0,0,1,3,3V27A3.009,3.009,0,0,1,27,30ZM3,1.5A1.5,1.5,0,0,0,1.5,3V27A1.5,1.5,0,0,0,3,28.5H27A1.5,1.5,0,0,0,28.5,27V3A1.5,1.5,0,0,0,27,1.5H22.462a7.5,7.5,0,0,1-14.925,0Zm0,0" />
      <path d="M266.668,160h6.75v1.5h-6.75Zm0,0" transform="translate(-247.918 -148.75)" />
    </svg>
  )
}

Shirt.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Shirt
